import "./blank.scss";
import "bootstrap/js/dist/util";
import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/dropdown";
import "bootstrap/js/dist/modal";
import AOS from "aos";
import Forms from "./components/forms";
import Maps from "./components/google-maps";
import HeroCarousel from "./modules/hero-carousel";
import ProductsCarousel from "./modules/products-carousel";
import ProductSuggestions from "./modules/product-suggestions";
import TestimonialsCarousel from "./modules/testimonials-carousel";
import Timeline from "./modules/timeline";
import GalleryGrid from "./modules/gallery-grid";
import ColourSwatches from "./modules/colour-swatches";
import ImageComparison from "./modules/image-comparison";
import Shop from "./components/shop";
import Product from "./views/product";
import AddressLookup from "./components/address-lookup";
import Modal from "./components/modal";

window.App.aos = AOS;
window.$ = jQuery;

class App {
  static init() {
    AOS.init({ disable: "mobile" });

    new Forms().init();
    new Maps().init();
    new HeroCarousel().init();
    new ProductsCarousel().init();
    new ProductSuggestions().init();
    new TestimonialsCarousel().init();
    new Timeline().init();
    new GalleryGrid().init();
    new ColourSwatches().init();
    new ImageComparison().init();
    new Shop().init();
    new Product().init();
    new AddressLookup().init();
    new Modal().init();

    // $('.js-gallery-slider').on("lazyLoaded", function lazy(e, slick, image) {
    //   const parentSlide = $(image).parent(".photo");
    //   parentSlide.css("background-image", `url(${image.attr("src")})`).addClass("loaded");
    //   image.remove();
    // });

    if ($("[lightbox-gallery]").length) {
      (async () => {
        await import("lightgallery");
        await import("lg-thumbnail");
        await import("lg-zoom");

        $("[lightbox-gallery]").each((_, item) => {
          $(item).lightGallery({
            thumbnail: true,
            selector: "a",
            exThumbImage: "data-thumb",
            subHtmlSelectorRelative: true,
          });
        });
      })();
    }

    let timeout;
    $(".woocommerce").on("change", "input.qty", () => {
      if (timeout !== undefined) {
        clearTimeout(timeout);
      }
      timeout = setTimeout(() => {
        $("[name='update_cart']").trigger("click");
      }, 500);
    });

    $(".js-toggle-search").on("click", () => {
      $(".custom-navbar .search-form").toggleClass("shown");
      const state = $(".custom-navbar .search-form").hasClass("shown");
      $(".js-toggle-search .icon-normal").toggleClass("d-none", state);
      $(".js-toggle-search .icon-active").toggleClass("d-none", !state);
    });

    $("button.hamburger").on("click", () => {
      $("button.hamburger").toggleClass("is-active");
      $(".mobile-menu").toggleClass("shown");
      $("body").toggleClass("position-fixed overflow-hidden");
    });
  }
}

App.init();
